import React from 'react';
import { Link } from 'react-router-dom';
import { reopenConsent } from '@/lib/consent';

// Solange DRAFT true ist, zeigt die Seite einen Entwurfs-Hinweis. Auf false setzen,
// sobald die Angaben in [eckigen Klammern] geklaert und rechtlich geprueft sind.
// Quelle des Textes: SecondBrain bess-plattform/agb-pruefung.md (Datenschutzerklaerung-Entwurf).
const DRAFT = true;

const TABLE = [
  ['IP-Adresse, Zeit, aufgerufene Seite (Server-Logs)', 'Betrieb, Sicherheit', 'Art. 6 Abs. 1 lit. f DSGVO', 'Hosting auf eigenem Server'],
  ['Benutzername, E-Mail, Telefon (optional), Passwort als Hash', 'Konto, Login, Verifizierung', 'Art. 6 Abs. 1 lit. b', 'Datenbank-Anbieter, E-Mail-Dienst'],
  ['Anmelde-Token im Browser', 'Angemeldet bleiben', 'Art. 6 Abs. 1 lit. b, § 25 Abs. 2 TDDDG', 'keine'],
  ['Name, E-Mail, Telefon bei Interessenbekundung', 'Kontaktaufnahme zum Projekt', 'Art. 6 Abs. 1 lit. b', 'Datenbank-Anbieter'],
  ['Beteiligung: Anteile, Beträge, Zahlungsstand, Kündigungsgrund', 'Vertragsabwicklung', 'Art. 6 Abs. 1 lit. b, lit. c', 'Datenbank-Anbieter'],
  ['Kontoinhaber, IBAN, BIC, Bankname', 'Auszahlung von Erträgen', 'Art. 6 Abs. 1 lit. b', 'Datenbank-Anbieter'],
  ['Flächenangebot: Name, E-Mail, Telefon, Lage und Größe der Fläche, Nachricht, hochgeladene Fotos, Pläne und PDFs', 'Prüfung und Beantwortung des Angebots', 'Art. 6 Abs. 1 lit. a (Einwilligung) und lit. b (vorvertragliche Maßnahmen)', 'Datenbank-Anbieter, E-Mail-Dienst, eigener Server und interne Dateiablage'],
  ['E-Mails (Bestätigung, Passwort-Reset, Ertragsmitteilung) und Protokoll', 'Vertragsdurchführung', 'Art. 6 Abs. 1 lit. b', 'E-Mail-Dienst'],
  ['reCAPTCHA bei der Registrierung', 'Spamschutz', 'Einwilligung, Art. 6 Abs. 1 lit. a, § 25 Abs. 1 TDDDG', 'Google'],
  ['Google-Ads-Tag (wenn eingetragen)', 'Werbemessung', 'Einwilligung, Art. 6 Abs. 1 lit. a, § 25 Abs. 1 TDDDG', 'Google'],
];

const SECTIONS = [
  {
    title: '1 Verantwortlicher',
    paras: [
      'Verantwortlich für die Datenverarbeitung auf dieser Plattform ist: Andreas Speier, Einzelunternehmer, handelnd unter "Speier Solarbetriebe", Am Graben 54, 68623 Lampertheim, E-Mail info@speier-solar.de, Telefon 0163 6970566.',
      'Einen Datenschutzbeauftragten hat der Verantwortliche nicht benannt. [Prüfen, ob eine Benennungspflicht besteht.]',
    ],
  },
  { title: '2 Welche Daten wofür verarbeitet werden', table: true },
  {
    title: '3 Hosting und Server-Logs',
    paras: [
      'Die Plattform läuft auf einem eigenen Server des Verantwortlichen. Beim Aufruf verarbeitet der Webserver technisch notwendige Verbindungsdaten: IP-Adresse, Datum und Uhrzeit, aufgerufene Adresse, übertragene Datenmenge und Browserkennung. Das dient dem sicheren Betrieb und der Fehlersuche (Art. 6 Abs. 1 lit. f DSGVO). Die Daten werden [x Tage] gespeichert und nicht mit anderen Daten zusammengeführt.',
      'Der Zugang zur Seite läuft über einen dynamischen DNS-Dienst, damit die Adresse trotz wechselnder IP erreichbar bleibt. [Anbieter nennen, falls er Verbindungsdaten verarbeitet.]',
    ],
  },
  {
    title: '4 Registrierung, Benutzerkonto und Login',
    paras: [
      'Für ein Konto speichern wir Benutzername, E-Mail-Adresse, optional eine Telefonnummer, Ihre Rolle auf der Plattform, den Verifizierungsstatus und den Zeitpunkt der Registrierung. Ihr Passwort wird nicht im Klartext, sondern nur als Hash gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.',
      'Zur Bestätigung Ihrer E-Mail-Adresse und für das Zurücksetzen des Passworts senden wir Ihnen E-Mails mit einem Link, der ein einmaliges Token enthält. Die Registrierung kann durch Google reCAPTCHA v2 geschützt sein (siehe Abschnitt 7).',
    ],
  },
  {
    title: '5 Beteiligung und Vertragsabwicklung',
    paras: [
      'Wenn Sie Interesse an einem Projekt bekunden, speichern wir Name, E-Mail-Adresse und Telefonnummer, um Sie zu kontaktieren. Bei einer Beteiligung speichern wir Projekt, Anzahl der Anteile, Betrag, Zahlungsstufen und Zahlungsstand, das Datum der Zahlung, interne Zahlungsnotizen sowie bei einer Kündigung den Antrag, den von Ihnen genannten Grund und die Entscheidung.',
      'Flächenangebote: Wenn Sie über die Hauptseite eine Fläche anbieten, speichern wir Ihre Angaben (Name, E-Mail, optional Telefon, Ort, Flurstück, Größe, Art, Verhältnis zur Fläche, Entfernung zum Umspannwerk, Verfügbarkeit, Nachricht) und optional hochgeladene Anlagen (JPG, PNG oder PDF, bis zu 5 Dateien). Die Angaben liegen in der Datenbank, Anlagen und eine Zusammenfassung zusätzlich in einem Ordner je Angebot auf unserem eigenen Server und in unserer internen Dateiablage (Nextcloud im eigenen Netz). Die Anlagen sind nicht öffentlich abrufbar, Zugriff haben nur berechtigte Mitarbeiter. Sie erhalten eine Eingangsbestätigung per E-Mail, und wir benachrichtigen intern. Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die Sie jederzeit widerrufen können, und die Anbahnung eines Vertrags (lit. b). Abgelehnte Angebote löschen wir spätestens nach [Frist eintragen, Vorschlag 12 Monate]. Bitte laden Sie keine Unterlagen mit Daten Dritter hoch, die dafür nicht freigegeben sind.',
      'Für die Auszahlung von Erträgen speichern wir Kontoinhaber, IBAN, BIC und Bankname. Diese Bankdaten prüft ein Mitarbeiter, bevor sie freigegeben werden. Zugriff haben nur Mitarbeiter mit der Rolle Admin oder Finanzen.',
      'Rechtsgrundlage ist die Durchführung des Vertrags (Art. 6 Abs. 1 lit. b DSGVO) und, soweit Aufbewahrungspflichten bestehen, eine rechtliche Verpflichtung (lit. c). [Falls eine Identifizierung nach dem Geldwäschegesetz verlangt wird, hier Art, Umfang und Aufbewahrung ergänzen.]',
    ],
  },
  {
    title: '6 Speicherung im Browser',
    paras: [
      'Die Plattform setzt keine eigenen Cookies. Sie speichert im lokalen Speicher Ihres Browsers (localStorage) Ihr Anmelde-Token, damit Sie angemeldet bleiben, die gewählte Sprache und Ihre Auswahl zu den Google-Diensten. Das Token ist für den Login technisch erforderlich (§ 25 Abs. 2 Nr. 2 TDDDG) und wird beim Abmelden gelöscht.',
      'Ihre Auswahl zu Google-Diensten können Sie jederzeit über "Cookie-Einstellungen" im Footer ändern.',
      'Auf der Startseite zählen wir Seitenaufrufe mit einem einfachen Zähler. Gespeichert wird nur die Gesamtzahl und die Zahl je Tag, ohne IP-Adresse, ohne Cookie und ohne Speicherung im Browser, ein Bezug zu Ihnen ist nicht möglich (berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO, Reichweitenmessung).',
    ],
  },
  {
    title: '7 Externe Dienste und Empfänger',
    paras: [
      'Datenbank (MongoDB Atlas): Die Plattformdaten liegen in einer Datenbank von MongoDB, Inc. [Rechenzentrumsstandort und Region eintragen, Auftragsverarbeitung und Drittlandtransfer prüfen.]',
      'E-Mail-Versand (IONOS): E-Mails werden über den SMTP-Server von IONOS versendet. Inhalt und Empfänger werden im E-Mail-Protokoll der Plattform gespeichert. [AV-Vertrag bestätigen.]',
      'Datensicherung (Microsoft Azure Blob Storage, optional): Wenn eingerichtet, werden Backups dort abgelegt. [Prüfen, ob aktiv, sonst streichen.]',
      'Spamschutz (Google reCAPTCHA v2): Nur mit Ihrer Einwilligung. Dann lädt Ihr Browser Inhalte von Google und übermittelt u. a. IP-Adresse und Browserdaten an Google (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG). Ohne Einwilligung ist die Online-Registrierung nicht möglich, Sie können uns dann per E-Mail kontaktieren.',
      'Werbemessung (Google Ads): Nur mit Ihrer Einwilligung. Dann lädt die Seite das Google-Tag (googletagmanager.com). Sie können die Einwilligung jederzeit widerrufen.',
      'Ohne Weitergabe an Dritte: Die Textübersetzung ins Englische läuft über LibreTranslate auf dem eigenen Server. Plattform-Updates holt ein interner Dienst bei GitHub, dabei werden keine Anlegerdaten übertragen.',
    ],
  },
  {
    title: '8 Speicherdauer',
    paras: [
      'Kontodaten speichern wir, solange das Konto besteht, und löschen sie danach, soweit keine Aufbewahrungspflichten entgegenstehen. Vertrags- und Zahlungsdaten bewahren wir nach den handels- und steuerrechtlichen Fristen auf, in der Regel sechs bis zehn Jahre (§ 257 HGB, § 147 AO). Server-Logs löschen wir nach [x Tagen]. Tokens zur Bestätigung und für das Zurücksetzen des Passworts gelten nur kurz und werden danach ungültig.',
    ],
  },
  {
    title: '9 Ihre Rechte',
    paras: [
      'Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18) und Datenübertragbarkeit (Art. 20). Sie können der Verarbeitung auf Grundlage berechtigter Interessen jederzeit widersprechen (Art. 21). Eine erteilte Einwilligung können Sie jederzeit für die Zukunft widerrufen (Art. 7 Abs. 3). Wenden Sie sich dazu an die Adresse in Abschnitt 1.',
      'Sie können sich außerdem bei einer Datenschutz-Aufsichtsbehörde beschweren. Zuständig ist [zuständige Behörde eintragen und prüfen].',
      'Die Bereitstellung der Daten für Konto und Beteiligung ist für den Vertragsschluss erforderlich. Ohne sie kann kein Vertrag zustande kommen. Automatisierte Entscheidungsfindung einschließlich Profiling findet nicht statt.',
    ],
  },
];

const Datenschutz = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-12" data-testid="datenschutz-page">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-4xl font-bold text-slate-900 mb-6">Datenschutzerklärung</h1>

        {DRAFT && (
          <div className="mb-6 p-4 bg-amber-50 border border-amber-300 rounded-lg text-amber-900 text-sm" data-testid="datenschutz-draft">
            Entwurf, noch nicht rechtlich geprüft. Angaben in [eckigen Klammern] sind offen.
          </div>
        )}

        <div className="space-y-8 text-slate-700">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-2xl font-bold text-slate-900 mb-3">{s.title}</h2>
              {s.paras && s.paras.map((p, i) => (
                <p key={i} className="mb-3 leading-relaxed">{p}</p>
              ))}
              {s.table && (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border border-slate-200">
                    <thead className="bg-slate-100 text-left">
                      <tr>
                        <th className="p-2 border border-slate-200">Daten</th>
                        <th className="p-2 border border-slate-200">Zweck</th>
                        <th className="p-2 border border-slate-200">Rechtsgrundlage</th>
                        <th className="p-2 border border-slate-200">Empfänger</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TABLE.map((row) => (
                        <tr key={row[0]}>
                          {row.map((c) => (
                            <td key={c} className="p-2 border border-slate-200 align-top">{c}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-4 text-sm">
          <button type="button" onClick={reopenConsent} className="underline text-blue-700" data-testid="datenschutz-consent-settings">
            Cookie-Einstellungen ändern
          </button>
          <Link to="/bess/impressum" className="underline text-blue-700">Impressum</Link>
        </div>
      </div>
    </div>
  </div>
);

export default Datenschutz;
